import React from 'react';
import styles from './SimpleFileUpload.module.css';

const SimpleFileUpload = ({
  onFilesSelected,
  onFileRemove,
  uploadedFiles = [],
  multiple = true,
  accept = "image/*",
  className = "",
}) => {
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    onFilesSelected(files);
  };

  const handleFileRemove = (fileIndex) => {
    onFileRemove(fileIndex);
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className={`${styles.fileUploadContainer} ${className}`}>
      <input
        type="file"
        multiple={multiple}
        accept={accept}
        onChange={handleFileSelect}
        className={styles.fileInput}
        id="file-upload"
      />
      <label htmlFor="file-upload" className={styles.fileInputLabel}>
        <span className={styles.fileInputText}>Choose Files</span>
      </label>
      
      {uploadedFiles.length > 0 && (
        <div className={styles.fileList}>
          <h4 className={styles.fileListTitle}>Selected Files:</h4>
          {uploadedFiles.map((file, index) => (
            <div key={index} className={styles.fileItem}>
              <div className={styles.fileInfo}>
                <span className={styles.fileName}>{file.name}</span>
                <span className={styles.fileSize}>({formatFileSize(file.size)})</span>
              </div>
              <button
                type="button"
                onClick={() => handleFileRemove(index)}
                className={styles.removeButton}
                title="Remove file"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
      
      <small className={styles.helpText}>
        Max size: 10MB per file. Allowed types: jpg, jpeg, png
      </small>
    </div>
  );
};

export default SimpleFileUpload;
